import * as Yup from 'yup';

const requiredMessage = `This field is required`;

export const sampleEditFormValidationSchema = () => {
  const fields: any = {
    indication: Yup.string()
      .test('has-text-content', requiredMessage, (value) => {
        if (!value) {
          return false;
        }
        const text = value.replace(/<[^>]*>/g, '').trim();
        return text.length > 0;
      })
      .nullable(),
  };

  return Yup.object().shape(fields);
};
